/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=ee86c5ae&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ee86c5ae&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/jiayin-stock-website_1398_static_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__